import React, { useEffect } from "react";

import "@fontsource/archivo";
import "@samskip/frontend-components/dist/index.css";
import { PageProps } from "gatsby";
import { useTranslation } from "react-i18next";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { pageTitle } from "@assets/constants";
import { useAppDispatch, useAppSelector } from "@assets/hooks";
import { classNames } from "@assets/utilities/classNameUtilities";
import { Header, Footer, PasswordModal, SpinnerPage } from "@components";
import LanguageSwitcher from "@components/UserInfo/languageSwitcher";
import { withTrans } from "@components/WithTrans/withTrans";
import Routes from "@routes/routes";
import {
  getProfile,
  logout,
  userProfileState,
} from "@state/slices/userProfileSlice";

const Layout = ({ location: { search } }: PageProps) => {
  const dispatch = useAppDispatch();
  const { ready } = useTranslation();
  const userProfile = useAppSelector(userProfileState).userProfile;

  const searchParams = new URLSearchParams(search);
  const showLayout = !searchParams.has("noLayout", "1");

  useEffect(() => {
    const selectedLanguage =
      window.localStorage.getItem("selectedLanguage") === "en" ? "en" : "is";
    document.title = `Samskip - ${pageTitle[selectedLanguage]}`;
    dispatch(getProfile());
  }, []);

  const handleLogout = () => {
    if (userProfile) {
      dispatch(logout(userProfile.Access));
    }
  };

  const getCurrentPath = () => {
    return `/${location.pathname.split("/")[1]}`;
  };

  if (!ready) {
    return <SpinnerPage className="h-screen" />;
  }

  return (
    <div className="theme-samskip" id="main-component">
      <div
        className={classNames(
          showLayout ? "flex flex-col gap-4" : "py-4",
          "bg-glacier-gray h-full w-full min-h-screen"
        )}
      >
        {showLayout ? (
          <Header
            logout={handleLogout}
            selectedMenu={getCurrentPath()}
            userProfile={userProfile}
          />
        ) : (
          <div className="w-full max-w-[1200px] mx-auto pb-2">
            <div className="flex flex-row-reverse">
              <LanguageSwitcher />
            </div>
          </div>
        )}
        <Routes />
        {showLayout && <Footer />}
      </div>
      <ToastContainer
        bodyClassName={() =>
          "my-auto mx-0 p-1.5 flex flex-auto items-center text-base text-neutral-900 font-semibold"
        }
        newestOnTop
      />
      <PasswordModal />
    </div>
  );
};

export default withTrans(Layout);
